import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { DialogComponent } from "../../common/DialogComponent";
import EFTDialog from "../EFTDialog";
import ProtectionPlanBillingInfo from "./ProtectionPlanBillingInfo";
import ProtectionPlanTermsAndCondition from "./ProtectionPlanTermsAndCondition";
import * as services from "../../../store/service";
import parse, { domToReact } from "html-react-parser";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { IPackage } from "../../../store/protectionPlanService/business/types";
import { Notification } from "../../common/Notification";
import { ISmbLicenseLimit } from "../../../store/protectionPlanService/business/types";
import LegalDocumentContainer from "../../LegalDocumentPages/LegalDocumentContainer";
import { useTranslation } from "react-i18next";
import BusinessProtectionPlanUpgradeCompleteDialog from "./BusinessProtectionPlanUpgradeCompleteDialog";

interface IProps {
    closeDialog: any;
    dialogId: string;
    packageIndex: number;
    closeUpgradeAndOpenCompletionDialog: any;
    subscriptionTypeChange: boolean;
    licenseLimit: string;
    setBillingInfoRequest: any;
    setBillingInfoChanged: any;
    packages: any;
    keepPackage: boolean;
    isTwoStepCancellation: boolean;
}
const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
});
const BusinessProtectionPlanUpgradePackage: React.FunctionComponent<IProps> = (props) => {
    const { getTermsOfUseURL, getPrivacyNoticeURL, getPrivacyNoticeLinkText, getTermsOfUseLinkText } = LegalDocumentContainer();
    const [showBillingInfoDialog, setShowBillingInfoDialog] = useState(false);
    const [tncDialog, setTncDialog] = useState(false);
    const [EFTdialog, setEFTDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState<any>({ EFTData: [], isEFTChecked: false });
    const [termsData, setTermsData] = useState<any>(null);
    const [loadingPaymentInfo, setLoadingPaymentInfo] = useState(false);
    const [loadingAmountDetail, setLoadingAmountDetail] = useState(false);
    const [loadingTnc, setLoadingTnc] = useState(false);
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const packageList = useSelector((state: ApplicationState) => {
        return state.protectionPlanBusinessState?.protectionPlanData?.smbLicenseLimits?.find((it: ISmbLicenseLimit) => it.key === props.licenseLimit)?.packageList;
    });
    const hasSontiqBrand = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasSontiqBrand
            ? state.configurationState.configuration.partnerConfig.hasSontiqBrand === "true"
                ? true
                : false
            : false
    );
    const currentPackage = packageList?.find((pkg) => pkg.IsActive);
    const selectedPackage = (packageList && packageList.length >= props.packageIndex ? packageList[props.packageIndex] : null) as IPackage;
    const licenseLimitSelector = useSelector((state: ApplicationState) => {
        return state.protectionPlanBusinessState?.protectionPlanData?.LicenseLimit;
    });
    const [paymentMethodDetails, setPaymentMethodDetails] = useState<any>();
    const [paymentInfoState, setPaymentInfoState] = useState({
        name: "",
        cardOrAccNumber: "",
        exp: "",
        paymentMethod: "",
        address: {
            addressline1: "",
            addressline2: "",
            city: "",
            state: "",
            zipCode: "",
        },
    });
    const [amountDetailState, setAmountDetailState] = useState({
        difference: 0,
        currentCharge: 0,
        amountTobeCreditedOrCharged: 0,
        creditedAmount: 0,
        newCharge: 0,
        nextBillingDate: "",
        billingCycleDescription1: "",
        billingCycleDescription2: "",
        billingCycleDescription3: "",
        tax: "",
        refundAmount: "",
        todaysNetCharge: "",
    });
    const [refundState, setRefundState] = useState({
        packageIndex: -1,
        billingLabel: "",
        bilingAmount: 0,
        billingText: "",
        subscriptionType: "",
        subscriptionCharge: "",
        salesTax: "",
        newCharge: "",
    });
    const [isCompleted, setCompletion] = useState(false);
    const [isLoader, setLoader] = useState(true);

    const isKeepPackageUpgrade = props.keepPackage && Number(selectedPackage.Featurevalue) > Number(licenseLimitSelector);
    const isKeepPackageDowngrade = props.keepPackage && Number(selectedPackage.Featurevalue) < Number(licenseLimitSelector);
    const { t: tLang } = useTranslation();

    const handleBillingCloseDialog = (value: string): any => {
        if (value === "show") {
            setShowBillingInfoDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setShowBillingInfoDialog(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setShowBillingInfoDialog(false);
            getPaymentDetailsData();
        }
    };
    const showBillingInformation = (event: any) => {
        handleBillingCloseDialog("show");
    };

    const handleTncDialog = (value: string): any => {
        if (value === "show") {
            setTncDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setTncDialog(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setTncDialog(false);
        }
    };

    const { register, errors, handleSubmit } = useForm({
        mode: "onSubmit",
    });

    const getChangeType = () => {
        if (!props.subscriptionTypeChange && selectedPackage?.ActionButtonText?.toLowerCase() === "cancel" && !props.keepPackage) {
            return "CANCEL";
        } else if (selectedPackage.ActionButtonText?.toLowerCase() === "purchase") {
            return "PURCHASE";
        } else if (selectedPackage.ActionButtonText?.toLowerCase() === "renew") {
            return "PURCHASE";
        } else return "CHANGE";
    };

    const reverseSubscriptionType = (subscriptionType: string) => {
        if (subscriptionType?.toUpperCase() === "MONTHLY") {
            return "YEARLY";
        } else if (subscriptionType?.toUpperCase() === "YEARLY") {
            return "MONTHLY";
        }
        return "";
    };

    const getSubscriptionType = () => {
        let subscriptionType = selectedPackage?.SubcriptionType;
        if (props.subscriptionTypeChange) {
            subscriptionType = reverseSubscriptionType(subscriptionType);
        }
        return subscriptionType?.toUpperCase();
    };

    const onSubmit = (data: any) => {
        const requestBody = {
            catalogPackageID: selectedPackage?.CatalogPackageID,
            featureID: selectedPackage?.FeatureID,
            licenseLimit: selectedPackage?.Featurevalue,
            packageCode: selectedPackage?.PackageCode,
            packageId: selectedPackage?.PackagId,
            packagePrice: selectedPackage?.Price,
            changeType: getChangeType(),
            subscriptionType: getSubscriptionType(),
            billingInformation: null,
        };

        setLoading(true);
        services
            .SmbUpgradeDowngradePackage(requestBody)
            .then((data) => {
                setLoading(false);
                if (data && data.IsSuccess) {
                    let subscriptionType = getSubscriptionType() === "YEARLY" ? "New Yearly Subscription" : "New Monthly Subscription";
                    let subscriptionCharge = amountDetailState.newCharge;
                    let salesTax = amountDetailState.tax;
                    let billingText = data.BillingText;
                    let billingAmountLabel = getBillingAmountLabel();
                    let billingAmount = Number(amountDetailState.amountTobeCreditedOrCharged);
                    // to resolve bug 16845
                    if (selectedPackage.PartnerId === 428 && billingText) {
                        billingAmountLabel =
                            getSubscriptionType() === "YEARLY"
                                ? tLang("manageAccount.protectionPlan.billPaymentPopUp.newYearlySubscription")
                                : tLang("manageAccount.protectionPlan.billPaymentPopUp.newMonthlySubscription");
                    } else {
                        let nextBillingDate = (billingText && billingText.length >= 6 ? billingText.substring(billingText.indexOf("on the") + 6) : "").trim();
                        billingText = tLang("manageAccount.protectionPlan.billPaymentPopUp.billingMsg1");
                        if (nextBillingDate) {
                            if (getSubscriptionType() === "YEARLY") {
                                billingText +=
                                    tLang("manageAccount.protectionPlan.billPaymentPopUp.billingMsg2Annually") + "<strong>" + nextBillingDate + ".</strong>";
                            } else if (getSubscriptionType() === "MONTHLY") {
                                billingText +=
                                    tLang("manageAccount.protectionPlan.billPaymentPopUp.billingMsg2Monthly") + "<strong>" + nextBillingDate + ".</strong>";
                            }
                        }
                    }
                        props.closeUpgradeAndOpenCompletionDialog(
                            billingAmount,
                            billingAmountLabel,
                            billingText,
                            subscriptionType,
                            subscriptionCharge,
                            salesTax,
                            amountDetailState.newCharge
                        ); 
                } else if (data.errors) {
                    Notification({
                        type: "error",
                        title: dialogTitle(),
                        message: data.errors[0],
                        duration: 5,
                    });
                } else {
                    Notification({
                        type: "error",
                        title: dialogTitle(),
                        message: tLang("manageAccount.protectionPlan.notification.couldNotSaveInformationMsg"),
                        duration: 5,
                    });
                }
            })
            .catch(function (error) {
                setLoading(false);
            });
    };

    const handleCloseEFTDialog = (): any => {
        setEFTDialog(false);
    };
    const checked = () => {
        if (state.isEFTChecked) {
            setState({ ...state, isEFTChecked: false });
            return;
        }
        setState({ ...state, isEFTChecked: true });
    };

    const renderLicense = () => {
        return props.licenseLimit &&
            selectedPackage?.ActionButtonText &&
            (["upgrade", "downgrade"].includes(selectedPackage?.ActionButtonText?.toLowerCase()) || props.keepPackage)
            ? `- ${props.licenseLimit} Licenses`
            : "";
    };
    const dialogTitle = () => {
        if (props.subscriptionTypeChange && selectedPackage.IsActive) {
            let from =
                currentPackage?.SubcriptionType?.toLowerCase() === "monthly"
                    ? tLang("manageAccount.protectionPlan.billPaymentPopUp.monthly")
                    : tLang("manageAccount.protectionPlan.billPaymentPopUp.yearly");
            let to =
                from.toLowerCase() === "monthly"
                    ? tLang("manageAccount.protectionPlan.billPaymentPopUp.yearly")
                    : tLang("manageAccount.protectionPlan.billPaymentPopUp.monthly");
            return (
                tLang("manageAccount.protectionPlan.billPaymentPopUp.subscriptionChangingFromToTitle.text1") +
                from +
                tLang("manageAccount.protectionPlan.billPaymentPopUp.subscriptionChangingFromToTitle.text2") +
                to
            );
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "cancel" && !props.keepPackage) {
            return (
                tLang("manageAccount.protectionPlan.billPaymentPopUp.cancelPlanTitle.text1") +
                selectedPackage.PackageName +
                tLang("manageAccount.protectionPlan.billPaymentPopUp.plan")
            );
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "purchase") {
            return (
                tLang("manageAccount.protectionPlan.billPaymentPopUp.purchasePlanTitle.text1") +
                selectedPackage.PackageName +
                tLang("manageAccount.protectionPlan.billPaymentPopUp.plan")
            );
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "upgrade" || isKeepPackageUpgrade) {
            return (
                tLang("manageAccount.protectionPlan.billPaymentPopUp.upgradeToPlanTitle.text1") +
                selectedPackage.PackageName +
                tLang("manageAccount.protectionPlan.billPaymentPopUp.plan") +
                renderLicense()
            );
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "downgrade" || isKeepPackageDowngrade) {
            return (
                tLang("manageAccount.protectionPlan.billPaymentPopUp.downgradeToPlanTitle.text1") +
                selectedPackage.PackageName +
                tLang("manageAccount.protectionPlan.billPaymentPopUp.plan") +
                renderLicense()
            );
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "renew") {
            return tLang("manageAccount.protectionPlan.billPaymentPopUp.renew");
        } else {
            return "";
        }
    };

    const submitButtonLabel = () => {
        if (props.subscriptionTypeChange && selectedPackage.IsActive) {
            return "Change Subscription";
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "cancel" && !props.keepPackage) {
            return "Cancel Plan";
        } else {
            return props.keepPackage ? "Keep Package" : selectedPackage?.ActionButtonText;
        }
    };

    const getNewCharge = (data: any) => {
        if (!props.subscriptionTypeChange && selectedPackage?.ActionButtonText?.toLowerCase() === "cancel" && !props.keepPackage) {
            return 0;
        } else {
            return data.newCharge;
        }
    };

    const getBillingAmountLabel = () => {
        let label = "";
        const btnName = selectedPackage?.ActionButtonText?.toLowerCase();
        if (!props.keepPackage && (btnName === "downgrade" || btnName === "upgrade") && Number(selectedPackage.Featurevalue) !== Number(licenseLimitSelector)) {
            if (btnName === "downgrade") {
                label =
                    Number(amountDetailState.todaysNetCharge) > Number(amountDetailState.refundAmount)
                        ? tLang("manageAccount.protectionPlan.billPaymentPopUp.label.todaysNetCharge")
                        : tLang("manageAccount.protectionPlan.billPaymentPopUp.label.yourRefundIs");
            } else if (btnName === "upgrade") {
                label =
                    Number(amountDetailState.todaysNetCharge) > Number(amountDetailState.refundAmount)
                        ? tLang("manageAccount.protectionPlan.billPaymentPopUp.label.todaysNetCharge")
                        : tLang("manageAccount.protectionPlan.billPaymentPopUp.label.yourRefundIs");
            }
        } else if (props.subscriptionTypeChange) {
            const targetSubscriptionType = getSubscriptionType()?.toUpperCase();
            label =
                targetSubscriptionType === "YEARLY"
                    ? tLang("manageAccount.protectionPlan.billPaymentPopUp.label.todaysNetCharge")
                    : tLang("manageAccount.protectionPlan.billPaymentPopUp.label.yourRefundIs");
        } else {
            const action = selectedPackage?.ActionButtonText?.toLowerCase();
            label =
                action === "downgrade" || isKeepPackageDowngrade || (action === "cancel" && !props.keepPackage)
                    ? tLang("manageAccount.protectionPlan.billPaymentPopUp.label.yourRefundIs")
                    : tLang("manageAccount.protectionPlan.billPaymentPopUp.label.todaysNetCharge");
        }

        if (btnName === "downgrade" && Number(selectedPackage.Featurevalue)) {
            label =
                Number(amountDetailState.todaysNetCharge) > Number(amountDetailState.refundAmount)
                    ? tLang("manageAccount.protectionPlan.billPaymentPopUp.label.todaysNetCharge")
                    : tLang("manageAccount.protectionPlan.billPaymentPopUp.label.yourRefundIs");
        }
        if (props.keepPackage && Number(selectedPackage.Featurevalue) !== Number(licenseLimitSelector)) {
            label =
                Number(amountDetailState.todaysNetCharge) > Number(amountDetailState.refundAmount)
                    ? tLang("manageAccount.protectionPlan.billPaymentPopUp.label.todaysNetCharge")
                    : tLang("manageAccount.protectionPlan.billPaymentPopUp.label.yourRefundIs");
        }
        return label;
    };

    const getAmountCreditedOrCharged = (data: any) => {
        if (!props.keepPackage && selectedPackage && Number(selectedPackage.Featurevalue) !== Number(licenseLimitSelector)) {
            const btnName = selectedPackage?.ActionButtonText?.toLowerCase();
            if (btnName === "downgrade" || btnName === "upgrade") {
                return Number(data.todaysNetCharge) > Number(data.refundAmount) ? data.todaysNetCharge : data.refundAmount;
            }
        }
        if (selectedPackage?.ActionButtonText?.toLowerCase() === "downgrade" && Number(selectedPackage.Featurevalue)) {
            return Number(data.todaysNetCharge) > Number(data.refundAmount) ? data.todaysNetCharge : data.refundAmount;
        }
        if (data.difference <= 0) {
            if (props.subscriptionTypeChange || selectedPackage?.ActionButtonText?.toLowerCase() === "downgrade" || isKeepPackageDowngrade) {
                if (props.keepPackage && Number(selectedPackage.Featurevalue) !== Number(licenseLimitSelector)) {
                    return Number(data.todaysNetCharge) > Number(data.refundAmount) ? data.todaysNetCharge : data.refundAmount;
                }
                return data.refundAmount;
            } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "cancel" && !props.keepPackage) {
                return data.creditedAmount;
            }
        }
        if (
            Number(selectedPackage.Featurevalue) !== Number(licenseLimitSelector) &&
            selectedPackage?.ActionButtonText?.toLowerCase() === "cancel" &&
            !props.keepPackage
        ) {
            return data.creditedAmount;
        }

        return data.todaysNetCharge;
    };

    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");

        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    const getPaymentDetailsData = () => {
        if (selectedPackage?.DisplayPaymentInfo) {
            setLoadingPaymentInfo(true);
            services.GetPaymentDetail().then((data) => {
                setLoadingPaymentInfo(false);
                setPaymentMethodDetails({ ...paymentMethodDetails, data });
                if (data.billingAddress != null) {
                    const billing = data.billingAddress;
                    if (data.creditCard != null && data.creditCard.cardNumber != null) {
                        setPaymentInfoState({
                            ...paymentInfoState,
                            cardOrAccNumber: data.creditCard.cardNumber,
                            name: data.creditCard.nameOnCard,
                            exp: data.creditCard.expDateMo + "/" + data.creditCard.expDateYr,
                            paymentMethod: data.paymentMethod?.selection,
                            address: {
                                addressline1: billing.address1,
                                addressline2: billing.address2,
                                city: billing.city,
                                state: billing.state.selection,
                                zipCode: billing.zipCode,
                            },
                        });
                    } else if (data.eft != null && data.eft.accountNumber != null) {
                        setPaymentInfoState({
                            ...paymentInfoState,
                            cardOrAccNumber: data.eft.accountNumber,
                            name: data.eft.nameOnAccount,
                            paymentMethod: data.paymentMethod?.selection,
                            address: {
                                addressline1: billing.address1,
                                addressline2: billing.address2,
                                city: billing.city,
                                state: billing.state?.selection,
                                zipCode: billing.zipCode,
                            },
                        });
                    }
                }
            });
        }
    };
    const cancelPackage = () => {
        const requestBody = {
            catalogPackageID: selectedPackage?.CatalogPackageID,
            featureID: selectedPackage?.FeatureID,
            licenseLimit: selectedPackage?.Featurevalue,
            packageCode: selectedPackage?.PackageCode,
            packageId: selectedPackage?.PackagId,
            packagePrice: selectedPackage?.Price,
            changeType: getChangeType(),
            subscriptionType: getSubscriptionType(),
            billingInformation: null,
        };

        setLoading(true);
        services
            .SmbUpgradeDowngradePackage(requestBody)
            .then((data) => {
                setLoading(false);
                if (data && data.IsSuccess) {
                    let subscriptionType = "";
                    let subscriptionCharge = amountDetailState.newCharge;
                    let salesTax = amountDetailState.tax;
                    let billingText = "";
                    let billingAmountLabel = getBillingAmountLabel();
                    let billingAmount = Number(amountDetailState.amountTobeCreditedOrCharged);
                    
                        setRefundState({
                            ...refundState,
                            bilingAmount: billingAmount,
                            billingLabel: billingAmountLabel,
                            billingText: billingText,
                            subscriptionType: subscriptionType,
                            subscriptionCharge: String(subscriptionCharge),
                            salesTax: String(salesTax),
                            newCharge: String(amountDetailState.newCharge),
                        });
                    setCompletion(false);
                    setLoader(false);

                } else if (data.errors) {
                    Notification({
                        type: "error",
                        title: dialogTitle(),
                        message: data.errors[0],
                        duration: 5,
                    });
                } else {
                    Notification({
                        type: "error",
                        title: dialogTitle(),
                        message: tLang("manageAccount.protectionPlan.notification.couldNotSaveInformationMsg"),
                        duration: 5,
                    });
                }
            })
            .catch(function (error) {
                setLoading(false);
            });
    };

    useEffect(() => {
        services.getEFTInfo().then((data: any) => {
            setState({ ...state, EFTData: data });
        });

        getPaymentDetailsData();
    }, []);

    const getTncData = ({ packagePrice, packageCode, subscriptionType, salesTax }: any) => {
        setLoadingTnc(true);
        services
            .GetTermsAndConditionsInProtectionPlan({
                billingPrice: packagePrice,
                SubscriptionType: subscriptionType === "MONTHLY" ? "month" : "year",
                SalesTax: salesTax ? Number(salesTax) : 0,
                PackageCode: packageCode,
                IsPreviousbtnClick: false,
            })
            .then((res: any) => {
                setLoadingTnc(false);
                setTermsData(res);
            })
            .catch((err) => {
                setLoadingTnc(false);
            });
    };

    useEffect(() => {
        const requestBody = {
            packagePrice: selectedPackage?.Price,
            packageCode: selectedPackage?.PackageCode,
            subscriptionType: getSubscriptionType(),
            country: accountInfo && accountInfo.country ? accountInfo.country : "US",
            region: paymentInfoState.address && paymentInfoState.address.state ? paymentInfoState.address.state : "",
            EnrollmentType: null,
            changeType: "",
            street1: accountInfo && accountInfo.address1 ? accountInfo.address1 : "",
            street2: accountInfo && accountInfo.address2 ? accountInfo.address2 : "",
            city: accountInfo && accountInfo.city ? accountInfo.city : "",
            postalCode: accountInfo && accountInfo.zipCode ? accountInfo.zipCode : "",
            NewSMBLicenseLimit: "",
        };
        if (paymentInfoState && paymentInfoState.address) {
            requestBody.street1 = paymentInfoState.address.addressline1;
            requestBody.street2 = paymentInfoState.address.addressline2;
            requestBody.city = paymentInfoState.address.city;
            requestBody.postalCode = paymentInfoState.address.zipCode;
        }
        if (submitButtonLabel() === "Cancel Plan" && !props.keepPackage) {
            requestBody.changeType = "CANCEL";
        }
        if (props.packages[props.packageIndex] !== undefined) {
            requestBody.NewSMBLicenseLimit = props.packages[props.packageIndex]["Featurevalue"];
        }

        if (!selectedPackage?.PackageForCacellationContinuation || selectedPackage.ActionButtonText?.toLowerCase() === "renew") {
            setLoadingAmountDetail(true);
            services.getAvalaraService().then(() => {
                services.getUpgradePackageAmountDetails(requestBody).then((data) => {
                    setLoadingAmountDetail(false);
                    setAmountDetailState({
                        ...amountDetailState,
                        difference:
                            selectedPackage?.ActionButtonText?.toLowerCase() === "cancel" && !props.keepPackage
                                ? Number(data.currentMonthlyCharge) * -1
                                : data.difference,
                        currentCharge: data.currentMonthlyCharge,
                        creditedAmount: data.creditedAmount,
                        newCharge: getNewCharge(data),
                        amountTobeCreditedOrCharged: getAmountCreditedOrCharged(data),
                        nextBillingDate: data.newMonthlyChargeStartFrom,
                        billingCycleDescription1: data.billingCycleDescription1,
                        billingCycleDescription2: data.billingCycleDescription2,
                        billingCycleDescription3: data.billingCycleDescription3,
                        tax: data.tax ? data.tax : "0",
                        refundAmount: data.refundAmount,
                        todaysNetCharge: data.todaysNetCharge,
                    });
                    getTncData({
                        packagePrice: Number(getNewCharge(data)),
                        packageCode: requestBody.packageCode,
                        subscriptionType: requestBody.subscriptionType,
                        salesTax: data.tax,
                    });
                    setCompletion(true);
                });
            });
        } else {
            setAmountDetailState({
                ...amountDetailState,
                difference: 1, // to show todays net charge
                newCharge: selectedPackage.PackagePrice,
                amountTobeCreditedOrCharged: selectedPackage.PackagePrice,
            });
            getTncData({
                packagePrice: requestBody.packagePrice,
                packageCode: requestBody.packageCode,
                subscriptionType: requestBody.subscriptionType,
                salesTax: amountDetailState.tax,
            });
        }
    }, [paymentInfoState.address]);

    const options = {
        replace: ({ attribs, children }: any) => {
            if (!attribs) return;
            if (attribs.hasOwnProperty("href")) {
                if (attribs.href.indexOf("TermsAndConditions") !== -1) {
                    return hasSontiqBrand ? (
                        <a href="https://www.sontiq.com/terms-of-use/" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    ) : (
                        <a href={getTermsOfUseURL()} target="_blank">
                            {getTermsOfUseLinkText()}
                        </a>
                    );
                }

                if (attribs.href && attribs.href.indexOf("privacy-policy") !== -1) {
                    return (
                        <a href={getPrivacyNoticeURL()} target="_blank">
                            {getPrivacyNoticeLinkText()}
                        </a>
                    );
                }
            }
        },
    };

    useEffect(() => {
        props.setBillingInfoRequest(paymentMethodDetails);
    }, [paymentMethodDetails]);

    useEffect(() => {
        if (isCompleted && props.isTwoStepCancellation) {
            cancelPackage();
        }
    }, [isCompleted]);

    return (
        <React.Fragment>
            {!props.isTwoStepCancellation ?
                <>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <em className="las la-cube"></em>
                </div>
                <h1>{dialogTitle()}</h1>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} id="protection-plan-upgrade-form-container">
                <div className={loading || loadingAmountDetail ? "loading dialog-body" : "dialog-body"}>
                    <div className="form-row">
                        <h3 className="content-sub-title">{tLang("manageAccount.protectionPlan.billPaymentPopUp.cartSummary")}</h3>
                    </div>
                    <div className="line-divider margin-vertical-xs"></div>

                    <div className="form-row data-grid has-lines row-height-sm">
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label font-weight-bold" id="label-selected-plan">
                                        <strong>{tLang("manageAccount.protectionPlan.billPaymentPopUp.label.yourPlan")}</strong>
                                    </div>
                                </div>

                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-selected-plan">
                                        {selectedPackage?.PackageName} {renderLicense()}
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    {selectedPackage?.DisplayPaymentInfo && (
                        <div className="form-row data-grid has-lines row-height-sm">
                            <fieldset className="form-row inline">
                                <div className="row data-row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-payment-info">
                                            <p>
                                                <strong>{tLang("manageAccount.protectionPlan.billPaymentPopUp.label.paymentInfo")}</strong>
                                            </p>
                                        </div>
                                    </div>

                                    <div className={"col-xs-12 col-sm-8 col-no-gutter " + (loadingPaymentInfo ? "loading" : "")}>
                                        <div className="data-value" aria-labelledby="label-payment-info">
                                            <div className="row between-xs">
                                                <div className="col-xs col-no-gutter flex-grow-null">
                                                    {paymentInfoState.cardOrAccNumber ? (
                                                        <p>
                                                            {paymentInfoState.name && (
                                                                <span>
                                                                    {paymentInfoState.name}
                                                                    <br />
                                                                </span>
                                                            )}
                                                            {paymentInfoState.address.addressline1 && (
                                                                <span>
                                                                    {paymentInfoState.address.addressline1}
                                                                    <br />
                                                                </span>
                                                            )}
                                                            {paymentInfoState.address.addressline2 && (
                                                                <span>
                                                                    {paymentInfoState.address.addressline2}
                                                                    <br />
                                                                </span>
                                                            )}
                                                            <span>
                                                                {[
                                                                    paymentInfoState.address.city,
                                                                    [paymentInfoState.address.state, paymentInfoState.address.zipCode].join(" "),
                                                                ].join(", ")}
                                                                <br />
                                                            </span>
                                                            <span className="dialog-icon">
                                                                <em
                                                                    className={
                                                                        "las " +
                                                                        (paymentInfoState.paymentMethod === "CC" ? "la-credit-card " : "la-university ") +
                                                                        "inline-icon"
                                                                    }
                                                                ></em>{" "}
                                                                {paymentInfoState.cardOrAccNumber}
                                                                <br />
                                                            </span>
                                                            {paymentInfoState.exp && (
                                                                <span>
                                                                    {" "}
                                                                    Exp. {paymentInfoState.exp}
                                                                    <br />{" "}
                                                                </span>
                                                            )}
                                                        </p>
                                                    ) : (
                                                        <div className="msg-generic msg-small margin-top-xs">
                                                            <em className="las la-info-circle"></em>
                                                            {tLang("manageAccount.protectionPlan.billPaymentPopUp.label.noPaymentProfile")}
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="col-xs col-no-gutter flex-grow-null">
                                                    <span
                                                        className="default_link"
                                                        onClick={(e) => {
                                                            showBillingInformation(e);
                                                            window.addToDataLayer({ event: "Protection Plan - Billing Info" });
                                                        }}
                                                    >
                                                        <a href="javascript:void(0)" className="default_link">
                                                            {paymentInfoState.cardOrAccNumber
                                                                ? tLang("manageAccount.protectionPlan.billPaymentPopUp.btn.change")
                                                                : tLang("manageAccount.protectionPlan.billPaymentPopUp.btn.add")}
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        {!paymentInfoState.paymentMethod && selectedPackage?.ActionButtonText?.toLowerCase() !== "cancel" && (
                                            <div className="data-value">
                                                <input
                                                    type="text"
                                                    name="paymentMethod"
                                                    id="label-payment-method"
                                                    defaultValue={paymentInfoState.paymentMethod}
                                                    ref={register({ required: true })}
                                                    style={{ opacity: 0, height: 0, width: 0, float: "left" }}
                                                />
                                                {errors["paymentMethod"] && errors["paymentMethod"].type === "required" && (
                                                    <span className="form-error">
                                                        {tLang("manageAccount.protectionPlan.billPaymentPopUp.validation.paymentInfoRequired")}
                                                    </span>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    )}

                    {!selectedPackage?.PackageForCacellationContinuation && (
                        <div className="form-row data-grid has-lines row-height-sm">
                            <fieldset className="form-row inline">
                                <div className="row data-row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-current-charge">
                                            <strong>
                                                {currentPackage ? (
                                                    <React.Fragment>
                                                        {currentPackage?.SubcriptionType?.toUpperCase() === "MONTHLY"
                                                            ? tLang("manageAccount.protectionPlan.billPaymentPopUp.label.monthlyCharge")
                                                            : tLang("manageAccount.protectionPlan.billPaymentPopUp.label.yearlyCharge")}
                                                    </React.Fragment>
                                                ) : (
                                                    <React.Fragment>
                                                        {selectedPackage?.SubcriptionType?.toUpperCase() === "MONTHLY"
                                                            ? tLang("manageAccount.protectionPlan.billPaymentPopUp.label.monthlyCharge")
                                                            : tLang("manageAccount.protectionPlan.billPaymentPopUp.label.yearlyCharge")}
                                                    </React.Fragment>
                                                )}
                                            </strong>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="label-current-charge">
                                            ${Number(amountDetailState.currentCharge).toFixed(2)}
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    )}

                    <div className="form-row data-grid has-lines row-height-sm">
                        {Number(amountDetailState.tax) && selectedPackage ? (
                            <fieldset className="form-row inline">
                                <div className="row data-row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-plan-cost">
                                            <strong>{tLang("manageAccount.protectionPlan.billPaymentPopUp.label.planCost")}</strong>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="label-plan-cost">
                                            {formatter.format(amountDetailState.newCharge)}
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        ) : null}
                        {Number(amountDetailState.tax) ? (
                            <fieldset className="form-row inline">
                                <div className="row data-row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-sales-tax">
                                            <strong>{tLang("manageAccount.protectionPlan.billPaymentPopUp.label.salesTax")}</strong>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="label-sales-tax">
                                            ${Number(amountDetailState.tax).toFixed(2)}
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        ) : null}
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-monthly-charge">
                                        <strong>
                                            {getSubscriptionType()?.toUpperCase() === "MONTHLY"
                                                ? tLang("manageAccount.protectionPlan.billPaymentPopUp.label.monthlyCharge")
                                                : tLang("manageAccount.protectionPlan.billPaymentPopUp.label.yearlyCharge")}
                                        </strong>
                                    </div>
                                </div>

                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-monthly-charge">
                                        {Number(amountDetailState.tax)
                                            ? "$" + (Number(amountDetailState.newCharge) + Number(amountDetailState.tax)).toFixed(2)
                                            : "$" + Number(amountDetailState.newCharge).toFixed(2)}
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    {!selectedPackage?.PackageForCacellationContinuation &&
                        Number(amountDetailState.amountTobeCreditedOrCharged) !== Math.abs(amountDetailState.difference) && (
                            <div className="form-row data-grid has-lines row-height-sm">
                                <fieldset className="form-row inline">
                                    <div className="row data-row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id="label-difference">
                                                <strong>{tLang("manageAccount.protectionPlan.billPaymentPopUp.label.difference")}</strong>
                                            </div>
                                        </div>

                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="data-value" aria-labelledby="label-difference">
                                                {Number(amountDetailState.difference) < 0
                                                    ? "-$" + (Number(amountDetailState.difference) * -1).toFixed(2)
                                                    : "$" + Number(amountDetailState.difference).toFixed(2)}
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        )}

                    <div className="form-row data-grid row-height-sm">
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-todays-charge">
                                        <h4 className="status-good">{getBillingAmountLabel()}</h4>
                                    </div>
                                </div>

                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-todays-charge">
                                        <div className="row between-xs">
                                            <div className="col-xs col-no-gutter flex-grow-null">
                                                <h4 className="status-good">{"$" + Number(amountDetailState.amountTobeCreditedOrCharged).toFixed(2)}</h4>
                                            </div>
                                            {!selectedPackage?.PackageForCacellationContinuation &&
                                                !(selectedPackage?.ActionButtonText?.toLowerCase() === "purchase") &&
                                                paymentInfoState.cardOrAccNumber &&
                                                Number(amountDetailState.currentCharge) !== 0 && (
                                                    <div className="col-xs col-no-gutter flex-grow-null">
                                                        <button
                                                            aria-expanded="false"
                                                            type="button"
                                                            className="btn-default btn-toggle btn-no-padding"
                                                            id="btn_calculation_rule"
                                                            onClick={() => toggle("calculation_rule", "btn_calculation_rule")}
                                                        >
                                                            <span className="btn-toggle-status sr-only">
                                                                {tLang("manageAccount.protectionPlan.billPaymentPopUp.btn.show")}
                                                            </span>
                                                            <span className="btn-text">
                                                                {tLang("manageAccount.protectionPlan.billPaymentPopUp.btn.calculated")}
                                                            </span>
                                                        </button>
                                                    </div>
                                                )}
                                        </div>

                                        <div id="calculation_rule" style={{ display: "none" }}>
                                            <br />
                                            <p>{parse(amountDetailState.billingCycleDescription1)}</p>
                                            <p>{parse(amountDetailState.billingCycleDescription2)}</p>
                                            <p>{parse(amountDetailState.billingCycleDescription3)}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    <div className="msg-generic">
                        <div className="form-row data-grid">
                            <div className="form-input">
                                <label className="form-checkbox-label" htmlFor="isAgreed">

                                    <input type="checkbox" id="isAgreed" name="isAgreed" ref={register({ required: true })} />
                                    {submitButtonLabel() === "Cancel Plan" ? (
                                        <span className="form-checkbox-label-text">
                                            {tLang("manageAccount.protectionPlan.billPaymentPopUp.tandc.byCheckingBox")}
                                            <span className="default_link">
                                                &nbsp;
                                                {hasSontiqBrand ? (
                                                    <a href="https://www.sontiq.com/terms-of-use/" target="_blank">
                                                        {tLang("manageAccount.protectionPlan.billPaymentPopUp.tandc.termsOfUse")}
                                                    </a>
                                                ) : (
                                                    <a
                                                        href={getTermsOfUseURL()}
                                                        target="_blank"
                                                        onClick={() => {
                                                            window.addToDataLayer({ event: "Protection Plan - Show TNC" });
                                                        }}
                                                    >
                                                        {tLang("manageAccount.protectionPlan.billPaymentPopUp.tandc.termsOfUse")}
                                                    </a>
                                                )}{" "}
                                                {tLang("manageAccount.protectionPlan.billPaymentPopUp.tandc.and")}{" "}
                                                <a href={getPrivacyNoticeURL()} target="_blank">
                                                    {tLang("manageAccount.protectionPlan.billPaymentPopUp.tandc.privacyNotice")}
                                                </a>
                                                .
                                            </span>
                                        </span>
                                    ) : (
                                        <span className="form-checkbox-label-text" style={{ lineHeight: "1.5rem" }}>
                                            {termsData && termsData.content ? parse(termsData.content[0].value, options) : null}
                                        </span>
                                    )}
                                    {errors["isAgreed"] && errors["isAgreed"].type === "required" && (
                                        <span className="form-error">{tLang("manageAccount.protectionPlan.billPaymentPopUp.validation.agreetancRequired")}</span>
                                    )}
                                </label>
                            </div>
                        </div>

                        {paymentInfoState.paymentMethod === "EFT" && (
                            <div className="form-row data-grid">
                                <div className="form-input">
                                    <label className="form-checkbox-label" htmlFor="isEFTChecked">

                                        <input type="checkbox" id="isEFTChecked" name="isEFTChecked" ref={register({ required: true })} onChange={() => checked()} />
                                        <span className="form-checkbox-label-text">
                                            {tLang("manageAccount.protectionPlan.billingInformation.validation.I")}
                                            <span
                                                className="default_link"
                                                onClick={() => {
                                                    setEFTDialog(true);
                                                    window.addToDataLayer({ event: "Protection Plan - EFT Acknowledgement" });
                                                }}
                                            >
                                                &nbsp;
                                                <a href="javascript:void(0)" className="default_link">
                                                    {tLang("manageAccount.protectionPlan.billingInformation.validation.authorize")}
                                                </a>
                                                &nbsp;
                                            </span>
                                            {tLang("manageAccount.protectionPlan.billingInformation.validation.bankInfo")}
                                        </span>

                                        {errors["isEFTChecked"] && errors["isEFTChecked"].type === "required" && (
                                            <span className="form-error">
                                                {tLang("manageAccount.protectionPlan.billingInformation.validation.checkAuthRequired")}
                                            </span>
                                        )}
                                    </label>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="dialog-footer">
                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null"></div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button
                                type="submit"
                                className="btn-default btn-primary"
                                id="btn-submit-purchase"
                                disabled={loadingPaymentInfo || loadingAmountDetail || loadingTnc}
                                onClick={() => window.addToDataLayer({ event: "Protection Plan - Submit " + selectedPackage?.ActionButtonText?.toUpperCase() })}
                            >
                                <span className="btn-text">{submitButtonLabel()}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
            {showBillingInfoDialog && (
                <DialogComponent
                    dialogId="protection-plan-billing-information-dialog"
                    title={tLang("manageAccount.protectionPlan.billingInformation.title")}
                    datalayerEvent="Protection Plan - Close billing info"
                    closeDialog={() => {
                        handleBillingCloseDialog("close");
                    }}
                >
                    <ProtectionPlanBillingInfo
                        dialogId="protection-plan-billing-information-dialog"
                        setBillingInfoChanged={props.setBillingInfoChanged}
                        closeDialog={() => {
                            handleBillingCloseDialog("close");
                        }}
                        getSubscriptionType={getSubscriptionType}
                        selectedPackage={selectedPackage}
                    ></ProtectionPlanBillingInfo>
                </DialogComponent>
            )}

            {tncDialog && (
                <DialogComponent
                    dialogId="protection-plan-tnc-dialog"
                    title={tLang("manageAccount.protectionPlan.termsNConditions.title")}
                    datalayerEvent="Protection Plan - Close TNC"
                    closeDialog={() => handleTncDialog("close")}
                >
                    <ProtectionPlanTermsAndCondition
                        dialogId="protection-plan-tnc-dialog"
                        closeDialog={() => handleTncDialog("close")}
                        packageIndex={props.packageIndex}
                    ></ProtectionPlanTermsAndCondition>
                </DialogComponent>
            )}

            {EFTdialog && (
                <DialogComponent
                    dialogId="whatsIncluded"
                    hideCloseButton={true}
                    title={tLang("manageAccount.protectionPlan.billPaymentPopUp.yourCart")}
                    closeDialog={handleCloseEFTDialog}
                >
                    <EFTDialog data={state.EFTData} closeDialog={handleCloseEFTDialog}></EFTDialog>
                </DialogComponent>
                    )}
                </>
                : isLoader ?
            <div className="col-xs">
                <div className={`box offset-padding loading`}></div>
            </div> :

            <BusinessProtectionPlanUpgradeCompleteDialog
                        dialogId="protection-plan-upgrade-done-dialog"
                        closeDialog={() => { }}
                        billingLabel={refundState.billingLabel}
                        billingAmount={refundState.bilingAmount}
                        billingText={refundState.billingText}
                        subscriptionType={refundState.subscriptionType}
                        subscriptionCharge={refundState.subscriptionCharge}
                        salesTax={refundState.salesTax}
                        selectedPackage={selectedPackage}
                        subscriptionTypeChange={props.subscriptionTypeChange}
                        newCharge={refundState.newCharge}
                        isTwoStepCancellation={props.isTwoStepCancellation}
            />
             }
        </React.Fragment>
    );
};
export default BusinessProtectionPlanUpgradePackage;
